var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { DataValidityStatus, LINKS, goTo, isGBRCustomer } from '@raisin/cp-utils';
import { trackEvent } from '@raisin/events-tracking';
import { EVENTS } from '../../../eventsTracking';
const isDataValidityOutdated = (customer) => {
    var _a;
    const validity = (_a = customer === null || customer === void 0 ? void 0 : customer._embedded) === null || _a === void 0 ? void 0 : _a.dataValidity;
    return ((validity === null || validity === void 0 ? void 0 : validity.status) === DataValidityStatus.EXPIRED ||
        (validity === null || validity === void 0 ? void 0 : validity.status) === DataValidityStatus.REVALIDATE);
};
export const shouldRedirectCustomerToUpdateData = (customer) => !!customer && !isGBRCustomer(customer) && isDataValidityOutdated(customer);
export const redirectCustomerToUpdateData = () => __awaiter(void 0, void 0, void 0, function* () {
    yield trackEvent(EVENTS.CUSTOMER_REDIRECTED_TO_CDVC);
    goTo(LINKS.CUSTOMER.CDVC);
});
//# sourceMappingURL=cdvc.js.map